// Modules
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';

import { LONG_HUMAN_DATE_FORMAT } from 'constants';
import { RoundLoader } from 'components/widgets/state-indicators/loader';
import { superShortDate } from 'utils/format-utils';
import Task from 'services/data/task';
import Tooltip from 'components/widgets/overlays/tooltip';
import UserBadge from 'components/models/user/user-badge';


export default function NewTask({ task, className }) {
  const isOverdue = Task.isOverdue(task);
  const isToday = Task.isToday(task);
  const daysTilDue = Task.daysTilDue(task);
  
  return (
    <li className={`${className} new-task`}>
      <div className="task-contents">
        <div className="task-info">
          <RoundLoader color="#b0bec5" className="new-task-loader" />
          <div className="description-wrapper"><div className="description">{task.description}</div></div>
        </div>

        <div className="task-meta">
          <div className="assigned-to-flex-wrapper">
            <div className="assigned-to-wrapper">
              <div className="assigned-to">
                {_.map(task.assignedTo, (user) =>
                  <UserBadge key={user.id} user={user} />)
                }
              </div>
            </div>
          </div>
          <div className={classNames('urgency-pill', `urgency-${task.urgency.toLowerCase()}`)}>{task.priority}</div>
          <Tooltip className="task-date-wrapper" title={moment(task.dueDate).format(LONG_HUMAN_DATE_FORMAT)}>
            <div className={classNames('task-date', 'flex flex-mobile', { today: isToday, overdue: isOverdue })}>
              <span className="task-due-date">
                { isOverdue && 'Overdue' }
                { isToday && 'Due Today' }
                { !isOverdue && !isToday && daysTilDue < 30 && `Due ${daysTilDue}D` }
                { !isOverdue && !isToday && daysTilDue >= 30 && `Due ${superShortDate(task.dueDate)}` }
              </span>
            </div>
          </Tooltip>
        </div>
      </div>
    </li>
  );
}

NewTask.propTypes = {
  task: PropTypes.object.isRequired,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/models/ticket/new-task.js